import moment from "moment";

export const simpleDate = (date) => moment(date).format("DD/MM/YYYY");
export const simpleTime = (date) => moment(date).format("LT");
